import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询CRM客户类型
export function listCrmCustomerType(requestBody) {
  return request({
    url: URL.mdm.basicData.listCrmCustomerType,
    method: 'post',
    data: requestBody
  })
}

// 新增或更新CRM客户类型
export function saveCrmCustomerType(requestBody) {
  return request({
    url: URL.mdm.basicData.saveCrmCustomerType,
    method: 'post',
    data: requestBody
  })
}

// 删除CRM客户类型
export function deleteCrmCustomerType(requestBody) {
  return request({
    url: URL.mdm.basicData.deleteCrmCustomerType,
    method: 'post',
    data: requestBody
  })
}

// 获取已被使用的CRM客户类型
export function getUsedCrmCustomerType(requestBody) {
  return request({
    url: URL.mdm.basicData.getUsedCrmCustomerType,
    method: 'post',
    data: requestBody
  })
}
